import React, { useEffect } from "react";
import "../style/page/Research.css";
import ResearchTable from "../component/ResearchTable";
import { useResearchContent } from "../hooks/useResearchContent";

function Research() {
  const content = useResearchContent();

  // Update page title when content changes
  useEffect(() => {
    if (content.metaTitle) {
      document.title = content.metaTitle;
    }
  }, [content.metaTitle]);

  return (
    <main className="main-content research-page">
      <h4 className="page-title" data-translate="research.title">
        {content.title}
      </h4>

      <p className="description" data-translate="research.description">
        {content.description}
      </p>

      {/* BẢNG NGHIÊN CỨU */}
      <ResearchTable researchs={content.researchs} headerTexts={content.headerTexts} />
      {/* HẾT BẢNG NGHIÊN CỨU */}
    </main>
  );
}

export default Research;
